/* Фінконтроль (/fincontrol). Kept apart from uk.ts/en.ts to keep merges small. */
export const fincontrolUk = {
  'nav.fincontrol': 'Фінконтроль',
  'perm.fincontrol.read': 'Фінконтроль: знахідки, звірка ФОП × місяць, податковий календар, норми',
  'perm.fincontrol.manage': 'Фінконтроль: закривати знахідки, відмічати строки, змінювати норми й правила',
  'fincontrol.title': 'Фінконтроль',
  'fincontrol.subtitle': 'Усі гроші клініки в одній звірці: що не так, де, як виправити і яка норма закону цього вимагає. Перевірка щогодини.',
  'fincontrol.evaluate': 'Перевірити зараз',
  'fincontrol.evaluated': 'Перевірку виконано, нових знахідок: {n}',
  'fincontrol.tab.overview': 'Огляд',
  'fincontrol.tab.findings': 'Знахідки',
  'fincontrol.tab.matrix': 'ФОП × місяць',
  'fincontrol.tab.norms': 'Норми',
  'fincontrol.tab.rules': 'Правила',
  'fincontrol.sev.critical': 'Критичні',
  'fincontrol.sev.high': 'Високі',
  'fincontrol.sev.medium': 'Середні',
  'fincontrol.sev.low': 'Низькі',
  'fincontrol.status.open': 'Відкрита',
  'fincontrol.status.acknowledged': 'У роботі',
  'fincontrol.status.fixed': 'Виправлено',
  'fincontrol.status.false_positive': 'Не проблема',
  'fincontrol.status.resolved': 'Зникла після перевірки',
  'fincontrol.action.acknowledge': 'Взяти в роботу',
  'fincontrol.action.fix': 'Виправлено',
  'fincontrol.action.false_positive': 'Не проблема',
  'fincontrol.action.reopen': 'Відкрити знову',
  'fincontrol.action.note': 'Коментар',
  'fincontrol.ev.detected': 'знайдено',
  'fincontrol.ev.escalated': 'важливість зросла',
  'fincontrol.ev.acknowledged': 'взято в роботу',
  'fincontrol.ev.fixed': 'позначено виправленим',
  'fincontrol.ev.false_positive': 'позначено «не проблема»',
  'fincontrol.ev.reopened': 'відкрито знову',
  'fincontrol.ev.resolved': 'зникла після перевірки',
  'fincontrol.ev.note': 'коментар',
  'fincontrol.cat.prro': 'ПРРО / чеки',
  'fincontrol.cat.tax': 'Податки й ліміти',
  'fincontrol.cat.cash': 'Готівка й каси',
  'fincontrol.cat.fop': 'ФОПи й рахунки',
  'fincontrol.cat.sales': 'Продажі vs оплати',
  'fincontrol.cat.payments': 'Бонуси й борг',
  'fincontrol.cat.supply': 'Накладні',
  'fincontrol.cat.stock': 'Склад',
  'fincontrol.cat.calendar': 'Податковий календар',
  'fincontrol.cat.bank': 'Банк (BAS)',
  'fincontrol.cat.payroll': 'Зарплата (BAS)',
  'fincontrol.dl.done': 'Виконано',
  'fincontrol.dl.not_applicable': 'Не стосується',
  'fincontrol.dl.overdue': 'Прострочено',
  'fincontrol.dl.due_soon': 'Скоро',
  'fincontrol.dl.upcoming': 'Заплановано',
  'fincontrol.group.1': '1 група',
  'fincontrol.group.2': '2 група',
  'fincontrol.group.3': '3 група',
  'fincontrol.group.general': 'Загальна система',
  'fincontrol.groupMissing': 'Не вказано',
  'fincontrol.source.enote': 'Enote',
  'fincontrol.source.supply': 'Накладні',
  'fincontrol.source.inventory': 'Склад',
  'fincontrol.source.checkbox': 'Checkbox (ПРРО)',
  'fincontrol.source.bas': 'BAS (бухгалтерія)',
  'fincontrol.source.cashops': 'Касові операції',
  'fincontrol.sources': 'Джерела даних',
  'fincontrol.connected': 'підключено',
  'fincontrol.phase2': 'буде у фазі 2',
  'fincontrol.lastRun': 'Остання перевірка: {at}',
  'fincontrol.normsToConfirm': 'Норм, які має підтвердити бухгалтер: {n}.',
  'fincontrol.openNorms': 'Відкрити норми',
  'fincontrol.fopScores': 'Бал контролю по ФОП',
  'fincontrol.noFops': 'ФОПи ще не заведені',
  'fincontrol.noFopsHint': 'Додайте ФОПи клініки й прив’яжіть до них грошові рахунки Enote в «ФОПи та рахунки» — тоді з’являться бали й податковий календар.',
  'fincontrol.calendar': 'Податковий календар',
  'fincontrol.calendarHint': 'Строки розраховані з групи ЄП, виду (ФОП / ТОВ) і наявності працівників. Відмічайте сплату й подання — у фазі 2 це робитиме BAS.',
  'fincontrol.noDeadlines': 'Найближчих строків немає',
  'fincontrol.noDeadlinesHint': 'Вкажіть групу ЄП у картках ФОП, щоб побачити строки декларацій і платежів.',
  'fincontrol.markDone': 'Виконано',
  'fincontrol.markNA': 'Не стосується',
  'fincontrol.unmark': 'Зняти позначку',
  'fincontrol.col.fop': 'ФОП',
  'fincontrol.col.group': 'Група ЄП',
  'fincontrol.col.score': 'Бал',
  'fincontrol.col.open': 'Відкриті',
  'fincontrol.col.income': 'Дохід з 1 січня',
  'fincontrol.col.limit': 'Від ліміту',
  'fincontrol.col.due': 'Строк',
  'fincontrol.col.deadline': 'Що',
  'fincontrol.col.period': 'Період',
  'fincontrol.col.status': 'Статус',
  'fincontrol.col.severity': 'Важливість',
  'fincontrol.col.finding': 'Знахідка',
  'fincontrol.col.amount': 'Сума',
  'fincontrol.col.category': 'Розділ',
  'fincontrol.col.year': 'Рік',
  'fincontrol.col.norm': 'Норма',
  'fincontrol.col.value': 'Значення',
  'fincontrol.col.from': 'Діє з',
  'fincontrol.col.source': 'Джерело (акт, стаття)',
  'fincontrol.col.rule': 'Правило',
  'fincontrol.col.legal': 'Норма закону',
  'fincontrol.col.enabled': 'Увімкнено',
  'fincontrol.anySeverity': 'Будь-яка важливість',
  'fincontrol.activeStatuses': 'Відкриті й у роботі',
  'fincontrol.anyCategory': 'Усі розділи',
  'fincontrol.anyFop': 'Усі ФОПи',
  'fincontrol.noFop': 'ФОП не визначено',
  'fincontrol.search': 'Пошук у знахідках',
  'fincontrol.periodFilter': 'Період: {period}.',
  'fincontrol.noFindings': 'Проблем не знайдено',
  'fincontrol.noFindingsHint': 'За цим фільтром знахідок немає. Перевірка запускається щогодини; змініть фільтр або натисніть «Перевірити зараз».',
  'fincontrol.finding': 'Знахідка',
  'fincontrol.what': 'Що не так',
  'fincontrol.where': 'Де виправити',
  'fincontrol.how': 'Як виправити',
  'fincontrol.legal': 'Норма / джерело',
  'fincontrol.reason': 'Причина',
  'fincontrol.open': 'Відкрити',
  'fincontrol.expected': 'Очікувано / норма',
  'fincontrol.actual': 'Фактично',
  'fincontrol.note': 'Коментар або причина',
  'fincontrol.noteHint': 'Для «Не проблема» причина обов’язкова (напр. «оплата за IBAN, чек не потрібен»).',
  'fincontrol.reasonRequired': 'Вкажіть причину',
  'fincontrol.history': 'Історія',
  'fincontrol.year': 'Рік',
  'fincontrol.matrixHint': 'Клітинка — дохід ФОП за місяць; колір — стан звірки. Натисніть, щоб побачити знахідки.',
  'fincontrol.openN': 'відкр.: {n}',
  'fincontrol.noMatrix': 'Оплат за рік ще немає',
  'fincontrol.noMatrixHint': 'Матриця заповниться, коли з Enote синхронізуються оплати, прив’язані до ФОП через грошові рахунки.',
  'fincontrol.m.cash': 'Готівка',
  'fincontrol.m.card': 'Картка',
  'fincontrol.m.other': 'Інше / борг',
  'fincontrol.m.bonus': 'Бонуси',
  'fincontrol.m.returns': 'Повернення',
  'fincontrol.m.noReceipt': 'Без чека',
  'fincontrol.m.gap': 'Не фіскалізовано',
  'fincontrol.m.unpaid': 'Неоплачені продажі',
  'fincontrol.m.open': 'Відкриті знахідки',
  'fincontrol.normsHint': 'Числа, з якими працюють правила: МЗП, ліміти ЄП, ставки, строки, ліміти готівки. «Потребує підтвердження» — бухгалтер має звірити з актом і підтвердити.',
  'fincontrol.normsSearch': 'Пошук норми',
  'fincontrol.noNorms': 'Норм немає',
  'fincontrol.norm.confirmed': 'Підтверджено',
  'fincontrol.norm.to_confirm': 'Потребує підтвердження',
  'fincontrol.conf.high': 'достовірність висока',
  'fincontrol.conf.medium': 'достовірність середня',
  'fincontrol.conf.low': 'достовірність низька',
  'fincontrol.sourceLink': 'Посилання на джерело',
  'fincontrol.historyOf': 'Історія: {title}',
  'fincontrol.editOf': 'Змінити: {title}',
  'fincontrol.addValue': 'Нове значення з дати',
  'fincontrol.addValueHint': 'Нове значення діятиме з обраної дати (напр. МЗП наступного року); попередні роки зберігають свої значення.',
  'fincontrol.badValue': 'Число або JSON, напр. 8647 чи [80, 90, 100]',
  'fincontrol.reasonHint': 'Чому змінюється: закон, лист ДПС, рішення бухгалтера.',
  'fincontrol.noHistory': 'Змін ще не було',
  'fincontrol.system': 'система',
  'fincontrol.waitsFor': 'Чекає джерела: {sources}',
  'fincontrol.toggleRule': 'Увімкнути правило «{title}»',
}

export const fincontrolEn: { [K in keyof typeof fincontrolUk]?: string } = {
  'nav.fincontrol': 'Financial control',
  'perm.fincontrol.read': 'Financial control: findings, ФОП × month matrix, tax calendar, norms',
  'perm.fincontrol.manage': 'Financial control: close findings, mark deadlines, edit norms and rules',
  'fincontrol.title': 'Financial control',
  'fincontrol.subtitle': 'All the clinic’s money in one reconciliation: what is wrong, where, how to fix it and which legal norm requires it. Checked hourly.',
  'fincontrol.evaluate': 'Check now',
  'fincontrol.evaluated': 'Check done, new findings: {n}',
  'fincontrol.tab.overview': 'Overview',
  'fincontrol.tab.findings': 'Findings',
  'fincontrol.tab.matrix': 'ФОП × month',
  'fincontrol.tab.norms': 'Norms',
  'fincontrol.tab.rules': 'Rules',
  'fincontrol.sev.critical': 'Critical',
  'fincontrol.sev.high': 'High',
  'fincontrol.sev.medium': 'Medium',
  'fincontrol.sev.low': 'Low',
  'fincontrol.status.open': 'Open',
  'fincontrol.status.acknowledged': 'Acknowledged',
  'fincontrol.status.fixed': 'Fixed',
  'fincontrol.status.false_positive': 'False positive',
  'fincontrol.status.resolved': 'Resolved',
  'fincontrol.action.acknowledge': 'Acknowledge',
  'fincontrol.action.fix': 'Mark fixed',
  'fincontrol.action.false_positive': 'False positive',
  'fincontrol.action.reopen': 'Reopen',
  'fincontrol.action.note': 'Comment',
  'fincontrol.ev.detected': 'detected',
  'fincontrol.ev.escalated': 'escalated',
  'fincontrol.ev.acknowledged': 'acknowledged',
  'fincontrol.ev.fixed': 'marked fixed',
  'fincontrol.ev.false_positive': 'false positive',
  'fincontrol.ev.reopened': 'reopened',
  'fincontrol.ev.resolved': 'resolved',
  'fincontrol.ev.note': 'comment',
  'fincontrol.cat.prro': 'PRRO / receipts',
  'fincontrol.cat.tax': 'Taxes & limits',
  'fincontrol.cat.cash': 'Cash & registers',
  'fincontrol.cat.fop': 'ФОПи & accounts',
  'fincontrol.cat.sales': 'Sales vs payments',
  'fincontrol.cat.payments': 'Bonuses & credit',
  'fincontrol.cat.supply': 'Supplier invoices',
  'fincontrol.cat.stock': 'Stock',
  'fincontrol.cat.calendar': 'Tax calendar',
  'fincontrol.cat.bank': 'Bank (BAS)',
  'fincontrol.cat.payroll': 'Payroll (BAS)',
  'fincontrol.dl.done': 'Done',
  'fincontrol.dl.not_applicable': 'Not applicable',
  'fincontrol.dl.overdue': 'Overdue',
  'fincontrol.dl.due_soon': 'Due soon',
  'fincontrol.dl.upcoming': 'Upcoming',
  'fincontrol.group.1': 'Group 1',
  'fincontrol.group.2': 'Group 2',
  'fincontrol.group.3': 'Group 3',
  'fincontrol.group.general': 'General system',
  'fincontrol.groupMissing': 'Not set',
  'fincontrol.source.enote': 'Enote',
  'fincontrol.source.supply': 'Supplier invoices',
  'fincontrol.source.inventory': 'Stock',
  'fincontrol.source.checkbox': 'Checkbox (PRRO)',
  'fincontrol.source.bas': 'BAS (accounting)',
  'fincontrol.source.cashops': 'Cash operations',
  'fincontrol.sources': 'Data sources',
  'fincontrol.connected': 'connected',
  'fincontrol.phase2': 'phase 2',
  'fincontrol.lastRun': 'Last check: {at}',
  'fincontrol.normsToConfirm': 'Norms the accountant must confirm: {n}.',
  'fincontrol.openNorms': 'Open norms',
  'fincontrol.fopScores': 'Control score per ФОП',
  'fincontrol.noFops': 'No ФОПи yet',
  'fincontrol.noFopsHint': 'Add the clinic’s ФОПи and map Enote money accounts to them in «ФОПи та рахунки» to see scores and the tax calendar.',
  'fincontrol.calendar': 'Tax calendar',
  'fincontrol.calendarHint': 'Deadlines follow the single-tax group, kind (ФОП / ТОВ) and employees. Mark payments and filings — in phase 2 BAS will do it.',
  'fincontrol.noDeadlines': 'No upcoming deadlines',
  'fincontrol.noDeadlinesHint': 'Set the single-tax group on the ФОП cards to see declaration and payment deadlines.',
  'fincontrol.markDone': 'Done',
  'fincontrol.markNA': 'N/A',
  'fincontrol.unmark': 'Unmark',
  'fincontrol.col.fop': 'ФОП',
  'fincontrol.col.group': 'Tax group',
  'fincontrol.col.score': 'Score',
  'fincontrol.col.open': 'Open',
  'fincontrol.col.income': 'Income YTD',
  'fincontrol.col.limit': 'Of limit',
  'fincontrol.col.due': 'Due',
  'fincontrol.col.deadline': 'What',
  'fincontrol.col.period': 'Period',
  'fincontrol.col.status': 'Status',
  'fincontrol.col.severity': 'Severity',
  'fincontrol.col.finding': 'Finding',
  'fincontrol.col.amount': 'Amount',
  'fincontrol.col.category': 'Area',
  'fincontrol.col.year': 'Year',
  'fincontrol.col.norm': 'Norm',
  'fincontrol.col.value': 'Value',
  'fincontrol.col.from': 'From',
  'fincontrol.col.source': 'Source (act, article)',
  'fincontrol.col.rule': 'Rule',
  'fincontrol.col.legal': 'Legal reference',
  'fincontrol.col.enabled': 'Enabled',
  'fincontrol.anySeverity': 'Any severity',
  'fincontrol.activeStatuses': 'Open & acknowledged',
  'fincontrol.anyCategory': 'All areas',
  'fincontrol.anyFop': 'All ФОПи',
  'fincontrol.noFop': 'No ФОП',
  'fincontrol.search': 'Search findings',
  'fincontrol.periodFilter': 'Period: {period}.',
  'fincontrol.noFindings': 'No problems found',
  'fincontrol.noFindingsHint': 'Nothing matches the filter. The check runs hourly; change the filter or press «Check now».',
  'fincontrol.finding': 'Finding',
  'fincontrol.what': 'What is wrong',
  'fincontrol.where': 'Where to fix',
  'fincontrol.how': 'How to fix',
  'fincontrol.legal': 'Legal reference',
  'fincontrol.reason': 'Reason',
  'fincontrol.open': 'Open',
  'fincontrol.expected': 'Expected / norm',
  'fincontrol.actual': 'Actual',
  'fincontrol.note': 'Comment or reason',
  'fincontrol.noteHint': 'A reason is required for «False positive» (e.g. «IBAN transfer, no receipt needed»).',
  'fincontrol.reasonRequired': 'Enter a reason',
  'fincontrol.history': 'History',
  'fincontrol.year': 'Year',
  'fincontrol.matrixHint': 'A cell is the ФОП’s income for the month; the colour is the reconciliation state. Click to see findings.',
  'fincontrol.openN': 'open: {n}',
  'fincontrol.noMatrix': 'No payments this year yet',
  'fincontrol.noMatrixHint': 'The matrix fills once Enote payments mapped to ФОПи via money accounts are synced.',
  'fincontrol.m.cash': 'Cash',
  'fincontrol.m.card': 'Card',
  'fincontrol.m.other': 'Other / credit',
  'fincontrol.m.bonus': 'Bonuses',
  'fincontrol.m.returns': 'Returns',
  'fincontrol.m.noReceipt': 'Without receipt',
  'fincontrol.m.gap': 'Not fiscalised',
  'fincontrol.m.unpaid': 'Unpaid sales',
  'fincontrol.m.open': 'Open findings',
  'fincontrol.normsHint': 'The numbers the rules use: minimum wage, single-tax limits, rates, deadlines, cash limits. «To confirm» — the accountant must check against the act and confirm.',
  'fincontrol.normsSearch': 'Search norms',
  'fincontrol.noNorms': 'No norms',
  'fincontrol.norm.confirmed': 'Confirmed',
  'fincontrol.norm.to_confirm': 'To confirm',
  'fincontrol.conf.high': 'high confidence',
  'fincontrol.conf.medium': 'medium confidence',
  'fincontrol.conf.low': 'low confidence',
  'fincontrol.sourceLink': 'Source link',
  'fincontrol.historyOf': 'History: {title}',
  'fincontrol.editOf': 'Edit: {title}',
  'fincontrol.addValue': 'New value from a date',
  'fincontrol.addValueHint': 'The new value applies from the chosen date (e.g. next year’s minimum wage); earlier years keep theirs.',
  'fincontrol.badValue': 'A number or JSON, e.g. 8647 or [80, 90, 100]',
  'fincontrol.reasonHint': 'Why it changes: a law, a tax service letter, the accountant’s decision.',
  'fincontrol.noHistory': 'No changes yet',
  'fincontrol.system': 'system',
  'fincontrol.waitsFor': 'Waits for: {sources}',
  'fincontrol.toggleRule': 'Toggle rule «{title}»',
}
